export default __webpack_public_path__ + "static/media/Mechanical and Aerospace Engineering.3b42e712.pdf";